import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "form-field" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Select move out date", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", { class: "btn" }, "Cancel", -1)
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "form-field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, " Gate Key ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("small", null, "If you want to change the gate key, enter the new key here. ", -1)
const _hoisted_10 = { class: "form-field" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, " Unit Status", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { value: "available" }, "Available", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", { value: "unavailable" }, "Unavailable", -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 0,
  class: "form-field"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, "Archive Customer After Move Out", -1)
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Finalize Move Out ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Finalize Later")

import moment from "moment";

// import { useRouter } from "vue-router";
import { ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import BaseSpinner from "@/components/BaseSpinner.vue";

import api from "@virgodev/bazaar/functions/api";
// const router = useRouter();


export default /*#__PURE__*/_defineComponent({
  props: {
  customerId: {
    type: Number,
    required: true,
  },
  rentalId: {
    type: Number,
    required: true,
  },
  customerName: {
    type: String,
    required: true,
  },
  unitName: {
    type: String,
    required: true,
  },
  unitsLeft: {
    type: Number,
    required: true,
  },
  edit: {
    type: Number,
    required: true,
  },
  facilityId: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

const formErrors = ref<Record<string, string[]>>({});
const formSubmitting = ref(false);
const router = useRouter();
const route = useRoute();
const unitId = ref();
const errors = ref("");
const finalize = ref(false);
const formFields = ref({
  action: ref(),
  move_out_on: ref(),
  status: ref(),
  gate_key: ref(),
  archive: ref(false),
});


formFields.value.move_out_on = ref(moment().format("YYYY-MM-DD"));
async function submitForm() {
  formFields.value.action = "move_out";
  formFields.value.move_out_on = ref(moment().format("YYYY-MM-DD"));
  const json = JSON.parse(JSON.stringify(formFields.value));
  delete json.gate_key;
  delete json.status;

  formErrors.value = {};
  formSubmitting.value = true;
  let url = `finalize_move_out/?id=${props.rentalId}&facilityId=${props.facilityId}`;

  const responseData = await api({
    url,
    method: "PUT",
    json,
  });
  if ([200, 201].includes(responseData.status)) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    await updateUnit(responseData.body.unit_id);
    if (formFields.value.archive) {
      await archiveCustomer();
    }
  } else if (responseData.status === 400) {
    formErrors.value = responseData.body;
  } else {
    formErrors.value = {
      non_field_errors: [
        ("body" in responseData && responseData.body?.meta?.message) ||
          "The move-out was not completed and the facility did not say why. " +
            "Nothing was changed — check the rental before retrying.",
      ],
    };
  }
}
async function scheduleMoveOut() {
  if (
    moment(formFields.value.move_out_on).isSame(moment().format("YYYY-MM-DD"))
  ) {
    finalize.value = true;
  } else {
    formFields.value.action = "schedule_move_out";
    const json = JSON.parse(JSON.stringify(formFields.value));
    formErrors.value = {};
    formSubmitting.value = true;
    let url =
      "schedule_move_out/?id=" +
      props.rentalId +
      `&facilityId=${props.facilityId}`;
    const responseData = await api({
      url,
      method: "PUT",
      json,
    });

    if ([200, 201].includes(responseData.status)) {
      if (formFields.value.move_out_on == moment().format("YYYY-MM-DD")) {
        finalize.value = true;
      } else {
        router.push(
          typeof route.query.next === "string"
            ? route.query.next
            : {
                name: "customer_detail_ess",
                params: {
                  id: props.customerId,
                  facilityId: props.facilityId,
                },
              }
        );
      }
    } else {
      formErrors.value = {
        non_field_errors: [
          ("body" in responseData && responseData.body?.meta?.message) ||
            "The move-out was not scheduled and the facility did not say " +
              "why. Nothing was changed — check the rental before retrying.",
        ],
      };
    }
  }
}
async function archiveCustomer() {
  formErrors.value = {};
  formSubmitting.value = true;
  let url = `archive_customer/?id=${props.customerId}&facilityId=${props.facilityId}`;

  const responseData = await api({
    url,
    method: "DELETE",
  });

  formSubmitting.value = false;

  if (responseData.status === 200) {
    router.push(
      typeof route.query.next === "string"
        ? route.query.next
        : {
            name: "customers",
            params: {
              facilityId: props.facilityId,
              facilityName: "ESS",
            },
          }
    );
  } else if (responseData.status === 400) {
    formErrors.value = responseData.body;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}
async function updateUnit(id: string) {
  let json = JSON.parse(
    JSON.stringify({
      status: formFields.value.status,
      gate_key: formFields.value.gate_key,
    })
  );
  formErrors.value = {};
  formSubmitting.value = true;
  let url = `unit_status/?id=${id}&facilityId=${props.facilityId}`;

  const responseData = await api({
    url,
    method: "PUT",
    json,
  });

  formSubmitting.value = false;

  if (responseData.status === 200) {
    if (!formFields.value.archive) {
      router.push(
        typeof route.query.next === "string"
          ? route.query.next
          : {
              name: "customer_detail_ess",
              params: {
                id: props.customerId,
                facilityId: props.facilityId,
              },
            }
      );
    }
  } else if (responseData.status === 400) {
    formErrors.value = responseData.body;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}
async function getRental() {
  errors.value = "";
  const response = await api({
    url: `rentals/?id=${props.rentalId}&single=${true}&facilityId=${
      props.facilityId
    }`,
  });
  if (response.status == 200) {
    if (response.body.move_out_on) {
      if (props.edit != 1) {
        finalize.value = true;
      }
      unitId.value = response.body.unit_id;
      formFields.value.move_out_on = response.body.move_out_on;
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
getRental();

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_RouterLink, {
      to: {
      name: 'customer_detail_ess',
      params: { id: __props.customerId, facilityId: __props.facilityId },
    }
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Customer: " + _toDisplayString(__props.customerName), 1)
      ]),
      _: 1
    }, 8, ["to"]),
    _createElementVNode("form", {
      class: "large-width-centered",
      onSubmit: _withModifiers(submitForm, ["prevent"])
    }, [
      _createElementVNode("h1", null, "Schedule Move out of Unit " + _toDisplayString(__props.unitName), 1),
      (!finalize.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formFields.value.move_out_on) = $event)),
                type: "date"
              }, null, 512), [
                [_vModelText, formFields.value.move_out_on]
              ])
            ]),
            _createElementVNode("div", {
              class: "btn",
              onClick: scheduleMoveOut
            }, "Schedule move out"),
            _createVNode(_component_RouterLink, {
              to: {
          name: 'customer_detail_ess',
          params: { id: __props.customerId, facilityId: __props.facilityId },
        }
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["to"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formFields.value.gate_key) = $event)),
                type: "text"
              }, null, 512), [
                [_vModelText, formFields.value.gate_key]
              ]),
              _hoisted_9
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formFields.value.status) = $event)),
                class: "form-select",
                required: ""
              }, _hoisted_14, 512), [
                [_vModelSelect, formFields.value.status]
              ]),
              _createElementVNode("small", null, "Select what you would like the status of Unit " + _toDisplayString(__props.unitName) + " to be after this move out is complete.", 1)
            ]),
            (__props.unitsLeft == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formFields.value.archive) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, formFields.value.archive]
                  ]),
                  _hoisted_16
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn",
              type: "submit",
              disabled: formSubmitting.value
            }, [
              _hoisted_18,
              (formSubmitting.value)
                ? (_openBlock(), _createBlock(BaseSpinner, { key: 0 }))
                : _createCommentVNode("", true)
            ], 8, _hoisted_17),
            _createVNode(_component_RouterLink, {
              to: {
          name: 'customer_detail_ess',
          params: { id: __props.customerId, facilityId: __props.facilityId },
        }
            }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            }, 8, ["to"])
          ]))
    ], 40, _hoisted_1)
  ], 64))
}
}

})